import template from './batch.all.html';
import controller from './batch.all.controller';
import './batch.all.scss';

let batchallComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },

  template,
  controller
};

export default batchallComponent;


// WEBPACK FOOTER //
// ./client/app/components/batch/all/batch.all.component.js